module.exports = __webpack_public_path__ + "static/media/error.3aa7a89a.mp3";